import { render, staticRenderFns } from "./DepartureReport.vue?vue&type=template&id=0ca1ac0a&scoped=true&"
import script from "./DepartureReport.vue?vue&type=script&lang=js&"
export * from "./DepartureReport.vue?vue&type=script&lang=js&"
import style0 from "./DepartureReport.vue?vue&type=style&index=0&id=0ca1ac0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca1ac0a",
  null
  
)

export default component.exports